import React, { useState } from 'react';

const ContactUsSticky = () => {
  const [isOpen, setIsOpen] = useState(false);

  const contactOptions = [
    {
      icon: (
        <svg
          className="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>
      ),
      title: '+91-8010989509',
      description: null,
      action: () => console.log('Technical support clicked'),
    },
    {
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
          <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
        </svg>
      ),
      title: 'contact@rogerops.com',
      description: null,
      action: () => console.log('Order support clicked'),
    },
  ];

  return (
    <>
      {/* Contact Us Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="fixed bottom-6 right-6 bg-[#3498db] hover:bg-[#3498dbcc] text-white font-medium py-3 px-6 rounded-lg shadow-lg transition-all duration-300 z-50 flex items-center gap-2"
      >
        <svg
          class="uc-floating-svg"
          className="invert"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          width="28"
          height="28"
          viewBox="0 0 32 32"
          aria-hidden="true"
        >
          <path d="M16 0c-0.138-0.006-0.3-0.009-0.463-0.009-6.602 0-11.974 5.271-12.136 11.834v8.755h1.54v0.34c0 2.353 1.907 4.26 4.26 4.26v0h2v-11.18h-2c-1.555 0.009-2.912 0.85-3.649 2.1l-0.011 0.020v-4.28c0.161-5.397 4.575-9.711 9.996-9.711 0.163 0 0.326 0.004 0.487 0.012l-0.023-0.001c0.168-0.010 0.363-0.016 0.561-0.016 5.391 0 9.769 4.335 9.839 9.709v4.287c-0.738-1.253-2.068-2.089-3.596-2.12h-2.004v11.18h2c1.555-0.009 2.912-0.85 3.649-2.1l0.011-0.020v3.42l-6.46 3.38h-2.94v-1.86h-2.12v4h5.62l8-4.24v-16c-0.127-6.529-5.45-11.773-11.998-11.773-0.198 0-0.394 0.005-0.59 0.014l0.028-0.001zM7.080 18.26c0-0.001 0-0.002 0-0.003 0-1.129 0.882-2.051 1.994-2.116h0.006v6.9c-1.118-0.065-2-0.988-2-2.117 0-0.001 0-0.002 0-0.004v0zM24.92 20.92c0 0.001 0 0.002 0 0.003 0 1.129-0.882 2.051-1.994 2.116h-0.006v-6.9c1.118 0.065 2 0.988 2 2.117 0 0.001 0 0.002 0 0.004v0z"></path>
        </svg>
        Contact Us
      </button>

      {/* Contact Options Panel */}
      {isOpen && (
        <div className="fixed bottom-20 right-6 bg-white rounded-lg shadow-xl border border-gray-200 w-96 z-50">
          <div className="bg-[#3498db] text-white p-4 rounded-t-lg flex justify-between items-center">
            <h3 className="text-lg font-medium">How can we help you?</h3>
            <button
              onClick={() => setIsOpen(false)}
              className="text-white hover:text-gray-200 transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <div className="p-2">
            {contactOptions.map((option, index) => (
              <button
                key={index}
                onClick={option.action}
                className="w-full flex items-center gap-4 p-3 hover:bg-gray-50 rounded-lg transition-colors"
              >
                <div className="text-blue-700 flex-shrink-0">{option.icon}</div>
                <div className="text-left">
                  <h4 className="text-gray-900 font-medium">{option.title}</h4>
                  {option.description && (
                    <p className="text-sm text-gray-500">
                      {option.description}
                    </p>
                  )}
                </div>
              </button>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ContactUsSticky;


